var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHamburgerMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 50 39.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-hamburger-menu",
    d: "M22060.525,18469a3.529,3.529,0,0,1,0-7.059h31.035a3.529,3.529,0,0,1,0,7.059Zm0-16.473a3.528,3.528,0,1,1,0-7.057h42.941a3.528,3.528,0,1,1,0,7.057Zm0-16.467a3.529,3.529,0,0,1,0-7.059h42.941a3.529,3.529,0,0,1,0,7.059Z",
    transform: "translate(-22056.996 -18428.998)",
    fill: "#94939d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHamburgerMenu);
export default __webpack_public_path__ + "static/media/icon-hamburger-menu.0c97cdc284a59b72b903e111b71c91a0.svg";
export { ForwardRef as ReactComponent };